export const EXPORT_SCORING_RESULTS_REPORT_CSV_MESSAGES = {
  NOT_FOUND: 'No report was found',
};


// WEBPACK FOOTER //
// ./src/features/reports/constants/exportScoringResultsReportCsvMessages.js